import { Navigate } from 'react-router-dom'

/** Legacy route — redirects to unified Listings management (streaming section). */
export default function AdminStreamingCataloguePage() {
  return <Navigate to="/admin/listings-management#streaming" replace />
}
